import type { ContinueWatchingDtoContinueWatchingPageView } from '@bldsoft/cappie/api/wbs'
import type { ApiEffect } from '../../index.h'

import { createEffect } from 'effector'

// GET /v3/continue-watching
export const getContinueWatchingFx: ApiEffect<
  {
    page: number
    count?: number
    sortOrder?: string
    sortBy?: string
  },
  Array<ContinueWatchingDtoContinueWatchingPageView>
> = createEffect()
